import * as React from "react";

import {
    useInterval,
    useNotifications,
    Text,
    Button,
    RelodeTheme,
} from "../../../";
import { MessageNotificationIcon } from "../../../assets/icons";
import { useMessageCheckerContext } from "./messageCheckerProvider";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    makeStyles,
    createStyles,
} from "@material-ui/core";

export const MessageChecker = () => {
    const {
        actions: { getUnread },
        state: { newUnreadSignal },
    } = useMessageCheckerContext();

    const { actions: notifications } = useNotifications();

    useInterval(() => getUnread(), appConfig.messageCheckIntervalMs, true);

    React.useEffect(() => {
        if (newUnreadSignal > 0) {
            notifications.showSnack("custom", "you have unread messages", {
                canClose: true,
                autoCloseDuration: 10000,
                customIcon: <MessageNotificationIcon />,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newUnreadSignal]);

    return null;
};
